module.exports = __webpack_public_path__ + "img/chr_ts_21_4.2040fbc9.png";